import { createAction, props } from '@ngrx/store';
export const setChartData = createAction('[Fund Chart] Set chart data', props());
// Used by the Fund Chart Creator only. Updates just the chart_data slice so the Annotate
// tab can render expanded series, without round-tripping params/aiSummaries that the
// creator user just typed (param-hydration reducers ignore this action).
export const setChartSeries = createAction('[Fund Chart] Set chart series', props());
